// Tiling Accordion Component Class
class TilingAccordion {
    constructor(container) {
    this.container = container;
    this.accordionContainer = container.querySelector('.accordion-container');
    this.items = this.accordionContainer.querySelectorAll('.item');
    this.init();
    }

    init() {
    // 初始化：设置默认的第二个item为active状态的居中
    this.accordionContainer.classList.add('second-active');
    this.bindEvents();
    }

    bindEvents() {
    // 移动端不绑定hover事件
    if (window.innerWidth <= 768) return;

    this.items.forEach((item, index) => {
        item.addEventListener('mouseenter', () => this.handleItemHover(item, index));
        item.addEventListener('mouseleave', () => this.handleItemLeave());
    });
    }

    handleItemHover(item, index) {
    // 移除所有 item 的 active 类
    this.items.forEach((i) => i.classList.remove('active'));

    // 移除所有 container 的状态类
    this.accordionContainer.classList.remove('first-active', 'second-active', 'third-active');

    // 添加当前 item 的 active 类
    item.classList.add('active');

    // 根据 hover 的 item 位置添加对应的状态类
    if (index === 0) {
        this.accordionContainer.classList.add('first-active');
    } else if (index === 1) {
        this.accordionContainer.classList.add('second-active');
    } else if (index === 2) {
        this.accordionContainer.classList.add('third-active');
    }
    }

    handleItemLeave() {
    // 移除所有 item 的 active 类
    this.items.forEach((i) => i.classList.remove('active'));

    // 移除所有 container 的状态类
    this.accordionContainer.classList.remove('first-active', 'second-active', 'third-active');

    // 默认居中第二个 item
    this.accordionContainer.classList.add('second-active');
    }
}

// 初始化所有 Tiling Accordion 实例
document.addEventListener('DOMContentLoaded', function () {
    const tilingAccordionBoxes = document.querySelectorAll('.tiling-accordion-component-box');
    tilingAccordionBoxes.forEach(box => new TilingAccordion(box));
});